import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import Iframe from '../iframe';
import {
  getEncodedQs,
  getKey,
  staticPath,
  convertRupeeCharToUnicode,
  commas,
  calculateAmountPayable,
  equalsIgnoreCase
} from '../../utils/common';

import { API, TOKEN, FLOW } from '../../../../common/src/constant';
import { postInWindow, handlePostData, openPopUpWindow } from '../../utils/formPost';
import CONSTANT, { CACHE } from '../../utils/constants';
import { EVENT, log } from '../../common/logger';
import PaymodeOffer from '../offers/paymodeOffer';
import Renewal from '../subscription/renewal';

class BOC extends Component {
  hasValidationError = true;

  inputLength = 4;

  constructor(props) {
    super(props);
    this.frame = undefined;
    this.state = {
      insufficientBalance: true,
      balanceData: {},
      iframeError: false,
      balanceFetched: false,
      passcodeRequired: this.props.passcodeRequired,
      showError: false,
      errorText: '',
      payError: false,
      genericErrorMsg: CONSTANT.GENERIC_ERROR,
      sufficientBalanceForPaymentChecked: false // adding this variable so that on component did update we can check whether to call for sifficient amount check
    };
  }

  componentDidMount() {
    this.fetchBalance();
  }

  componentDidUpdate(previousProps) {
    if (
      this.props.option &&
      this.props.selected &&
      this.props.option.id !== this.props.selected.id
    ) {
      if (this.state.showError)
        this.setState({
          showError: false,
          errorText: '',
          sufficientBalanceForPaymentChecked: false
        });
    }
    /*
    on paymode change sufficientBalanceForPaymentChecked msg in set state to false since in add and pay
    sufficientBalanceForPaymentChecked was set true hence sufficient balance was not being called and pay button remained
    enabled in case of insufficient balance also
    * */
    if (
      getKey(this.props, 'option.id') !== getKey(this.props, 'selected.id') &&
      this.state.sufficientBalanceForPaymentChecked
    ) {
      this.setState({ sufficientBalanceForPaymentChecked: false });
    }

    const walletUsed = getKey(this.props, 'wallet.isUsed', false);
    const payEnabled = getKey(this.props, 'payEnabled', false);
    const previousPropsWalletUsed = getKey(previousProps, 'wallet.isUsed', false);
    const previousPropsPayEnabled = getKey(previousProps, 'payEnabled', false);
    /*
     * if wallet is toggled or the sufficientBalanceForPaymentChecked is false
     * (on paymode change sufficientBalanceForPaymentChecked msg in state is set to false)
     * also checking for payenabled since pay button is being disabled but when pcf is called paybutton
     * is being enabled again  so checking if paybutton val has changed from previous value then
     * also check for sufficient balance
     *  */

    if (
      this.props.option &&
      this.props.selected &&
      this.props.option.id === this.props.selected.id &&
      equalsIgnoreCase(getKey(this.props.selected, 'paymentMode'), this.props.paymentMode) &&
      (!this.state.sufficientBalanceForPaymentChecked ||
        walletUsed !== previousPropsWalletUsed ||
        payEnabled !== previousPropsPayEnabled)
    ) {
      this.checkForSufficientBalance();
    }
  }

  submit = () => {
    if (this.state.passcodeRequired) {
      const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
      const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
      // payload.data.body = { ...payload.query };
      let reqData = {
        body: {
          type: CONSTANT.SUBMIT,
          targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
          queryParams: payload.query,
          method: payload.method,
          requestData: { ...payload.data },
          paymode: { id: this.props.option.id, type: this.props.option.type },
          paymentMode: this.props.paymentMode,
          guestFlow: tokenData.tokenType !== TOKEN.TXN || false // because of use of sso token guest flow will be set to true
        }
      };
      reqData = { ...reqData.body, ...payload.data.body };
      reqData.inputLength = 4;
      reqData.shouldPostOpenWindowEvent = this.hasValidationError;
      log({
        eventType: EVENT.BOC_IFRAME_SUBMIT,
        paymentMode: reqData.paymentMode,
        payMode: this.props && this.props.option && this.props.option.type
      });
      !this.hasValidationError && openPopUpWindow(this.props.cache);
      this.frame && this.frame.postDataToIframe(reqData);
    } else {
      const payload = {
        paymentMode: this.props.paymentMode,
        authMode: CONSTANT['3D'],
        selectedPaymentModeId: this.props.option.id
      };
      this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
      log({
        eventType: EVENT.BOC_SUBMIT,
        paymentMode: payload.paymentMode,
        payMode: this.props && this.props.option && this.props.option.type
      });
      this.props.cache
        .getData(CACHE.API)
        .pay(payload)
        .then(res => {
          const notifyMerchant = getKey(
            this.props.cache.getData(CACHE.MERCHANT_CONFIG),
            'handler.notifyMerchant',
            undefined
          );
          if (getKey(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
          } else {
            const errorMsg = getKey(res, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
            }
            this.setState({ showError: true, errorText: errorMsg });
          }
          /* if postpaid is called just call handle after pay as it is as a normal function */
          if (this.props.paymentMode === CONSTANT.POSTPAID) {
            this.handleAfterPay(res);
          } else {
            postInWindow(this.handleAfterPay(res), this.props.cache);
          }
        })
        .catch(err => {
          const notifyMerchant = getKey(
            this.props.cache.getData(CACHE.MERCHANT_CONFIG),
            'handler.notifyMerchant',
            undefined
          );
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
          }
          postInWindow({}, this.props.cache);
        });
    }
  };

  fetchBalance = () => {
    this.props.cache
      .getData(CACHE.API)
      .balance(this.props.paymentMode)
      .then(res => {
        const balanceInfo = getKey(res, 'body.balanceInfo', undefined);
        if (balanceInfo) {
          let insufficientBalance;
          if (balanceInfo.value > 0) {
            this.setState({
              insufficientBalance: false,
              balanceFetched: true,
              balanceData: balanceInfo
            });
            insufficientBalance = false;
          } else {
            this.setState({
              balanceFetched: true,
              insufficientBalance: true
            });
            insufficientBalance = true;
          }
          log({
            eventType: EVENT.BALANCE_CHECKED,
            paymode: this.props.paymentMode,
            insufficientBalance
          });
          this.props.onPayChange(true);
        } else if (getKey(res, 'body.resultInfo.resultStatus') === 'F') {
          const errorMsg = getKey(res, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
          this.setState({ showError: true, errorText: errorMsg });
        }
      })
      .catch(err => {
        const errorMsg = getKey(err, 'body.resultInfo.resultMsg', undefined);
        this.setState({ showError: true, errorText: errorMsg });
      });
  };

  checkForSufficientBalance = () => {
    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    const amountPayable = calculateAmountPayable(
      this.props.cache.getData(CONSTANT.TXN_AMOUNT),
      paymentOptions.wallet,
      false,
      this.props.subscription
    );
    const balanceInfo = this.state.balanceData;
    if (parseFloat(amountPayable) > parseFloat(balanceInfo.value)) {
      const errorMsg = getKey(
        this.props,
        'initializeObject.messageObj.label.insufficientBalance',
        'You do not have enough balance for this payment'
      );
      this.setState({
        showError: true,
        errorText: errorMsg,
        sufficientBalanceForPaymentChecked: true
      });
      this.props.onPayChange(false);
    } else {
      this.setState({ showError: false, errorText: '', sufficientBalanceForPaymentChecked: true });
      this.state.balanceFetched ? this.props.onPayChange(true) : this.props.onPayChange(false);
    }
  };

  messageHandler = event => {
    if (
      !this.props.cache.getData(CACHE.STORE) ||
      getKey(event, 'data.calledFrom') !== 'passcode' ||
      getKey(event, 'data.instanceKey') !== this.props.instanceKey
    ) {
      return;
    }

    if (getKey(event, 'data.paymode.id', undefined) === this.props.option.id) {
      switch (event.data && event.data.type) {
        case CONSTANT.PAY_SUCCESS: {
          const payload = getKey(event, 'data.response', {});
          postInWindow(this.handleAfterPay(payload), this.props.cache);
          log({ eventType: EVENT.BOC_EVENT_PAY_SUCCESS });
          break;
        }
        // in case of payment fail show error
        case CONSTANT.PAY_FAIL: {
          const data = event.data.response;
          log({ eventType: EVENT.BOC_EVENT_PAY_FAIL });
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          if (
            getKey(data, 'body.resultInfo.resultStatus', '') === 'F' &&
            getKey(data, 'body.resultInfo.retry', '') === false
          ) {
            if (
              getKey(data, 'body.txnInfo.RESPCODE', '') === '1006' ||
              getKey(data, 'body.resultInfo.resultCode', '') === '1006'
            ) {
              this.props.onOverlayValueChange('');
              const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
              if (notifyMerchant && notifyMerchant.constructor === Function) {
                notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
              }
              this.props.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
            } else {
              data.body.content = data.body.txnInfo;
              handlePostData(data, this.props.cache);
            }
          } else if (
            getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
            getKey(data, 'body.resultInfo.retry') === true
          ) {
            this.props.cache.getData(CACHE.STORE).setState({
              overlayValue: CONSTANT.RETRY,
              retryMessage: getKey(data, 'body.resultInfo.resultMsg')
            });

            //  in case of reyr get fallback token from cache and set current access token
            //  and remove txn token to fetch new txn token
            if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
              const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const tokenData = this.props.cache.getData(CACHE.FALLBACK_TOKEN_DATA, {
                token: getKey(mConfig, 'data.token', ''),
                tokenType: TOKEN.ACCESS
              });
              this.props.cache.setData(CACHE.TOKEN_DATA, {
                token: tokenData.token,
                tokenType: tokenData.tokenType
              });
            }
          }
          postInWindow(data, this.props.cache, this.props.cache);
          break;
        }
        case 'payerror': {
          log({ eventType: EVENT.BOC_EVENT_PAY_ERROR });
          if (this.state.payError) {
            this.setState({ showError: false, errorText: '', payError: false });
          }
          postInWindow({}, this.props.cache);
          break;
        }
        case CONSTANT.CLIENT_VALIDATION: {
          log({ eventType: EVENT.BOC_EVENT_CLIENT_VALIDATION });
          postInWindow({}, this.props.cache);
          break;
        }
        case CONSTANT.SHOW_PROCESSING: {
          log({ eventType: EVENT.BOC_EVENT_SHOW_PROCESSING });
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
          break;
        }
        case CONSTANT.SET_VALIDATION_STATUS: {
          this.hasValidationError = getKey(event, 'data.hasError');
          break;
        }
        case CONSTANT.OPEN_POPUP_WINDOW: {
          const paymodeId = getKey(event, 'data.paymode.id', null);
          const optionId = getKey(this.props, 'option.id', null);
          /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
          if (paymodeId === optionId) {
            log({ eventType: EVENT.POPUP_WINDOW });
            openPopUpWindow(this.props.cache);
          }
          break;
        }
        case CONSTANT.GET_TXN_TOKEN_PAYLOAD: {
          log({ eventType: EVENT.BOC_GET_TXN_TOKEN_PAYLOAD });
          this.props.cache
            .getData(CACHE.API)
            .getAsyncPayload(API.PT, this.hasValidationError)
            .then(payload => {
              if (this.state.passcodeRequired) {
                const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
                const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
                const orderId = this.props.cache.getData(CACHE.ORDER_ID);
                if (config && config.flow === FLOW.DEFERRED) {
                  payload.data.body.orderId = orderId;
                  payload.query.orderId = orderId;
                }

                let reqData = {
                  body: {
                    type: CONSTANT.SUBMIT_WITH_TOKEN,
                    targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
                    queryParams: payload.query,
                    method: payload.method,
                    requestData: { ...payload.data },
                    paymode: { id: this.props.option.id, type: this.props.option.type },
                    paymentMode: this.props.paymentMode,
                    authMode: CONSTANT.OTP,
                    selectedPaymentModeId: this.props.option.id,
                    guestFlow: tokenData.tokenType !== TOKEN.TXN || false // because of use of sso token guest flow will be set to true
                  }
                };
                reqData = { ...payload.data.body, ...reqData.body };
                reqData.inputLength = 4;

                this.frame && this.frame.postDataToIframe(reqData);
              } else {
                const payloadObj = {
                  paymentMode: this.props.paymentMode,
                  authMode: CONSTANT['3D'],
                  selectedPaymentModeId: this.props.option.id
                };
                const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
                const orderId = this.props.cache.getData(CACHE.ORDER_ID);
                if (config && config.flow === FLOW.DEFERRED) {
                  payloadObj.data.body.orderId = orderId;
                  payloadObj.query.orderId = orderId;
                }

                log({
                  eventType: EVENT.BOC_SUBMIT,
                  paymentMode: payload.paymentMode,
                  payMode: this.props && this.props.option && this.props.option.type
                });
                this.props.cache
                  .getData(CACHE.API)
                  .pay(payload)
                  .then(res => {
                    const notifyMerchant = getKey(
                      this.props.cache.getData(CACHE.MERCHANT_CONFIG),
                      'handler.notifyMerchant',
                      undefined
                    );
                    if (getKey(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
                    } else {
                      const errorMsg = getKey(
                        res,
                        'body.resultInfo.resultMsg',
                        CONSTANT.GENERIC_ERROR
                      );
                      if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                        notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, res);
                      }
                      this.setState({ showError: true, errorText: errorMsg });
                    }
                    postInWindow(this.handleAfterPay(res), this.props.cache);
                  })
                  .catch(err => {
                    const notifyMerchant = getKey(
                      this.props.cache.getData(CACHE.MERCHANT_CONFIG),
                      'handler.notifyMerchant',
                      undefined
                    );
                    if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                      notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
                    }
                    postInWindow({}, this.props.cache);
                  });
              }
            })
            .catch(() => {
              // close processing screen
              this.props.onOverlayValueChange('');
            });
          break;
        }
        default: {
          break;
        }
      }
    }
  };

  handleAfterPay = response => {
    /* if paymode is postpaid just handle response like in case of wallet */
    if (this.props.paymentMode === CONSTANT.POSTPAID) {
      const { callBackUrl, txnInfo } = getKey(response, 'body', {});
      response.body.content = txnInfo;
      response.body.callbackUrl = callBackUrl;
      handlePostData(response, this.props.cache);
      return response;
    }
    const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
    response.body.content = content;
    response.body.callbackUrl = actionUrl;
    return response;
  };

  enableButton = () => true;

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
  };

  render(
    { option, isActive, initializeObject, isPromoAvailable, offers, paymentMode, instanceKey },
    { insufficientBalance, balanceFetched, balanceData, passcodeRequired, showError, errorText }
  ) {
    const offer = isPromoAvailable
      ? option && isActive
        ? getKey(offers, paymentMode)
        : getKey(option, 'paymentOfferDetails')
      : null;

    if (initializeObject) {
      initializeObject = { ...initializeObject, instanceKey, inputLength: this.inputLength };
    }
    /* using string fromcodepoint to convert the entity to javascript object */
    let label = initializeObject.messageObj && initializeObject.messageObj.label.availableBalance;
    label = convertRupeeCharToUnicode(label);

    return (
      <div
        className={`ptm-pay-method ptm-w100-ib checkout-bank-credit-${paymentMode} boc-${paymentMode}`}
        id="checkout-bank-credit"
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div className="ptm-radio-wrap">
          <label className="ptm-lbl">
            <input
              type="radio"
              name={`verify${instanceKey}`}
              className={`ptm-margin0`}
              checked={isActive}
              onClick={() => {
                this.onOptionSelect(option);
              }}
            />
            <span className="ptm-checkmark" />
            <div className="ptm-pay-method-cont">
              <p className="ptm-paymode-name">{option.displayName} </p>

              {!balanceFetched && (
                <p className="ptm-small-txt-link" onClick={() => this.fetchBalance()}>
                  {initializeObject.messageObj && initializeObject.messageObj.label.checkBalance}
                </p>
              )}
              {!insufficientBalance && balanceFetched && balanceData && balanceData.value && (
                <p className="ptm-small-txt">
                  {label}
                  {commas(balanceData.value)}
                </p>
              )}
              {insufficientBalance && balanceFetched && (
                <p className="ptm-small-txt ptm-msg-red">
                  {initializeObject.messageObj &&
                    initializeObject.messageObj.label.insufficientBalance}
                </p>
              )}
            </div>
          </label>
        </div>
        {option &&
          isActive &&
          !insufficientBalance &&
          balanceFetched &&
          passcodeRequired &&
          this.enableButton() && (
            <Iframe
              ref={r => (this.frame = r)}
              classname={'ptm-ppb-iframe'}
              option={option}
              postMessageHandler={this.messageHandler}
              src={`${staticPath()}/assets/iframes/passcode.html`}
              {...{ initializeObject }}
            />
          )}
        {offer && <PaymodeOffer offer={offer} applied={isActive} />}
        {option && isActive && <Renewal />}
        {showError && isActive ? <p className={`ptm-msg-red ptm-ppbl-msg`}>{errorText}</p> : null}
      </div>
    );
  }
}
export default connect(
  'selected, wallet, payEnabled, cache, instanceKey, subscription',
  onChange
)(BOC);



// WEBPACK FOOTER //
// ./components/bankOrCredit/index.js